import {processApiRequest} from "../Common/saga";
import * as ACTION from './constants';
import apiService from "./apiService";

export function* fetchShippingUsersSuggest(action) {
    yield processApiRequest(ACTION.FETCH_SHIPPING_USER_SUGGEST, () => apiService.fetchShippingUsersSuggest(), action.payload);
}